import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            filter: '',
            messageTitle: '',
            enTitle: '',
            messageText: '',
            enText: '',
            imageUrl: '',
            sendByEmail: false,
            sendByNotification: false,
            companies: [],
            selectedCompanyIds: []
        }
    },
    computed: {
        filteredCompany() {
            const f = this.filter.toLowerCase().trim();
            if (f.length === 0) return this.companies;
            return this.companies.filter(item =>
                (item.name || '').toLowerCase().indexOf(f) !== -1 ||
                (item.displayName || '').toLowerCase().indexOf(f) !== -1
            )
        },
        allFilteredSelected() {
            if (this.filteredCompany.length === 0) return false;
            return this.filteredCompany.every(c => this.selectedCompanyIds.includes(c.id));
        }
    },
    methods: {
        load: load,
        sendCampaign: sendCampaign,
        onChangeCheckCompany: onChangeCheckCompany,
        setSelectedCheckCompany: setSelectedCheckCompany,
        toggleSelectAll: toggleSelectAll,
        reset: reset,
        getBalanceStyle: getBalanceStyle,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        isMobile() {
            return window.innerWidth <= 850;
        },
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.load();
    },
}

function load() {
    let _self = this;
    AdminApiService.getCompanies(false)
        .then((response) => {
            _self.companies = response.data || [];
        })
        .catch((error) => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function clickSearch() {
    this.load();
}

function getBalanceStyle(company) {
    if (company.currentBalance < 0) return 'color: #c6353e;';
    if (company.currentBalance > 0) return 'color: #1f8b4c;';
    return '';
}

function onChangeCheckCompany(company) {
    const id = company.id;
    if (this.selectedCompanyIds.includes(id)) {
        this.selectedCompanyIds = this.selectedCompanyIds.filter(x => x !== id);
    } else {
        this.selectedCompanyIds.push(id);
    }
}

function setSelectedCheckCompany(company) {
    return this.selectedCompanyIds.includes(company.id)
}

function toggleSelectAll() {
    const visibleIds = this.filteredCompany.map(c => c.id);
    if (visibleIds.length === 0) return;

    if (this.allFilteredSelected) {
        this.selectedCompanyIds = this.selectedCompanyIds.filter(id => !visibleIds.includes(id));
    } else {
        const set = new Set(this.selectedCompanyIds);
        visibleIds.forEach(id => set.add(id));
        this.selectedCompanyIds = Array.from(set);
    }
}

function reset() {
    this.messageTitle = '';
    this.enTitle = '';
    this.messageText = '';
    this.enText = '';
    this.imageUrl = '';
    this.sendByEmail = false;
    this.sendByNotification = false;
    this.selectedCompanyIds = [];
}

function sendCampaign() {
    const title = this.messageTitle != null ? this.messageTitle.trim() : '';
    const text = this.messageText != null ? this.messageText.trim() : '';

    if (this.selectedCompanyIds.length === 0) {
        swal(LocService.t('label_error'), LocService.t('label_campaign_error_no_companies_selected'), 'warning')
        return;
    }

    if (title.length === 0) {
        swal(LocService.t('label_error'), LocService.t('label_campaign_error_title_required'), 'warning')
        return;
    }

    if (text.length === 0) {
        swal(LocService.t('label_error'), LocService.t('label_campaign_error_message_required'), 'warning')
        return;
    }

    const model = {
        title: title,
        enTitle: this.enTitle != null ? this.enTitle.trim() : '',
        text: text,
        enText: this.enText != null ? this.enText.trim() : '',
        companyIds: this.selectedCompanyIds,
        sentByEmail: this.sendByEmail,
        sentByPush: this.sendByNotification,
        imageUrl: this.imageUrl != null && this.imageUrl.trim().length > 0 ? this.imageUrl.trim() : null,
    };

    let _self = this;
    AdminApiService.createCompanyCampaign(model)
        .then(() => {
            swal(LocService.t('label_success'), LocService.t('label_success'), 'success')
            _self.reset();
        })
        .catch((error) => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Campaign/CompanyCampaign.js